// extracted by mini-css-extract-plugin
export var addButton = "_4a-d";
export var bullets = "_4a-e";
export var compact = "_4a-2";
export var container = "_4a-j";
export var extendedWarrantyModal = "_4a-f";
export var learn = "_4a-l";
export var learnMore = "_4a-g";
export var offeringOption = "_4a-3";
export var offeringPrice = "_4a-8";
export var offeringSubtitle = "_4a-7";
export var offeringTitle = "_4a-6";
export var offeringsContainer = "_4a-0";
export var pdpTilesBackground = "_4a-n";
export var plan = "_4a-m";
export var regular = "_4a-1";
export var remove = "_4a-k";
export var seeDetailsIcon = "_4a-i";
export var seeDetailsLink = "_4a-h";
export var selectedOption = "_4a-4";
export var shieldIcon = "_4a-b";
export var shieldIconCompact = "_4a-c";
export var subtitle = "_4a-a";
export var title = "_4a-9";
export var unselectedOption = "_4a-5";